import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "18", height: "18", x: "3", y: "3", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 8h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 12h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 16h10", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MenuSquare";
const MenuSquare = memo(themed(Icon));
export {
  MenuSquare
};
//# sourceMappingURL=menu-square.js.map
